export default "__VITE_ASSET__CUU8y0im__"